<template>
  <div id="wrap">
    <div id="content">
      <header>
        <img id="drSeptris" :src="doctor" alt="Dr Septris"> <h2>{{header}}</h2>

      </header>
      <div id="textContent"><slot></slot></div>
      <button @click="close">Continue</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "tutorialtip",
  data(){
    return {
      doctor: this.$store.getters.getImage('./cat2.png')
    }
  },
  methods: {
    close(){
      this.$emit('close');
    }
  },
  props: {
    header: String
  }
}
</script>

<style scoped lang="less">
@import (reference) "../assets/less/colors";
#wrap{
  background: rgba(0,0,0,0.3);
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
#content{
  background: @white;
  padding: 1.5em;
  width: 50em;
  max-width: 80%;
}
header{
  display: flex;
  align-items: center;
}
h2{
  padding: .3em 0 0 0.25em;
}
#drSeptris{
  height: 3.5em;
}
#textContent{
  margin: 1.5em 0;
}
</style>
